/**
 * Processing Workflows API Client
 *
 * Frontend wrapper for named processing workflows CRUD operations
 * Workflows define input/output storage, encoding presets, and workflow settings
 */

import axios from '@/axios'

export default {
  /**
   * Get all workflows for current organization
   */
  async getAll() {
    try {
      const response = await axios.get('/api/processing-workflows')
      return response.data
    } catch (error) {
      console.error('Get workflows error:', error)
      throw error
    }
  },

  /**
   * Get single workflow by ID
   */
  async getById(id) {
    try {
      const response = await axios.get(`/api/processing-workflows/${id}`)
      return response.data
    } catch (error) {
      console.error('Get workflow error:', error)
      throw error
    }
  },

  /**
   * Create new workflow
   */
  async create(data) {
    try {
      const response = await axios.post('/api/processing-workflows', data)
      return response.data
    } catch (error) {
      console.error('Create workflow error:', error)
      throw error
    }
  },

  /**
   * Update existing workflow
   */
  async update(id, data) {
    try {
      const response = await axios.put(`/api/processing-workflows/${id}`, data)
      return response.data
    } catch (error) {
      console.error('Update workflow error:', error)
      throw error
    }
  },

  /**
   * Delete workflow
   */
  async delete(id) {
    try {
      const response = await axios.delete(`/api/processing-workflows/${id}`)
      return response.data
    } catch (error) {
      console.error('Delete workflow error:', error)
      throw error
    }
  },

  /**
   * Set workflow as default for organization
   */
  async setDefault(id) {
    try {
      const response = await axios.post(`/api/processing-workflows/${id}/set-default`)
      return response.data
    } catch (error) {
      console.error('Set default workflow error:', error)
      throw error
    }
  }
}
